import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceStatus', ['cachedStatuses', 'selectedStatus']),
}

export const Methods = mapActions('deviceStatus', [
  'fetchStatuses',
  'selectStatus',
  'updateStatus',
  'selectStatusType',
])
